import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';

export function useMappingRules() {
  return useQuery({
    queryKey: ['mapping-rules'],
    queryFn: () => api.get('/mapping-rules'),
    staleTime: 60_000,
  });
}

export function useCreateMappingRule() {
  const qc = useQueryClient();
  return useMutation({
    // body: { category_id, operator: 'AND'|'OR', conditions: [{match_type, match_value}], priority? }
    mutationFn: (body) => api.post('/mapping-rules', body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['mapping-rules'] }),
  });
}

export function useUpdateMappingRule() {
  const qc = useQueryClient();
  return useMutation({
    // body: { id, operator?, conditions?, priority? } — conditions replace atomically when provided
    mutationFn: ({ id, ...body }) => api.patch(`/mapping-rules/${id}`, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['mapping-rules'] }),
  });
}

export function useDeleteMappingRule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.delete(`/mapping-rules/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['mapping-rules'] }),
  });
}
